export enum DocumentUploadType {
    DOCUMENT = 'Document',
    SOURCE = 'Source'
}